import React, { Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { LoadingScreen } from 'scenes/Dashboard/components-next/Loading'
import { Redirect, Route, Switch } from 'utils-next/routes'
import { ExtendableStyles, Testable } from 'utils-next/types'

import { CardContent } from '@mui/material'

import { CORPORATE_MANAGER_DETAILS_PATH } from '../../CorporateManager.routes'
import {
  CORPORATE_MANAGER_DETAILS_FORM_DATA_PATH,
  getCorporateDetailsFormDataPath,
} from './CorporateDetailsView.routes'
import { useCorporateDetailsViewStore } from './CorporateDetailsView.store'
import { CorporateDetailsFormView } from './scenes'
import { TemporalEntityId } from '../../../../../../entities-next/common'

export type CorporateDetailsViewContentProps = ExtendableStyles & Testable

export function CorporateDetailsViewContent({ className, style, ...otherProps }: CorporateDetailsViewContentProps) {
  const {
    state: { corporateId },
  } = useCorporateDetailsViewStore()

  return (
    <section className={className}>
      <CardContent {...otherProps}>
        <Suspense fallback={<LoadingScreen />}>
          <ErrorBoundary FallbackComponent={ErrorFallback}>
            <Switch>
              <Route path={CORPORATE_MANAGER_DETAILS_PATH} exact>
                <Redirect to={getCorporateDetailsFormDataPath(corporateId)} />
              </Route>
              <Route path={CORPORATE_MANAGER_DETAILS_FORM_DATA_PATH} component={CorporateDetailsFormView} exact />
              {corporateId !== TemporalEntityId.new && (
                <>
                  <Route path={CORPORATE_MANAGER_DETAILS_FORM_DATA_PATH} exact>
                    <Redirect to={getCorporateDetailsFormDataPath(corporateId)} />
                  </Route>
                  <Route path={CORPORATE_MANAGER_DETAILS_FORM_DATA_PATH} component={CorporateDetailsFormView} exact />
                </>
              )}
            </Switch>
          </ErrorBoundary>
        </Suspense>
      </CardContent>
    </section>
  )
}

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <pre>{error.stack}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  )
}
